import request, {requestJson} from '../main';
const service = ""
class MaterialApi {
    private url: string = service + "/material";
    public page(args: any){
        return request({
            url: this.url + '/page-v2',
            method: 'get',
            params: args
        })
    }

    public pageMaterialOrg(args: any){
        return request({
            url: this.url + '/page-material-org',
            method: 'get',
            params: args
        })
    }

    public get(id: number){
        return request({
            url: this.url + '/get',
            method: 'get',
            params: {id: id}
        })
    }

    public edit(args: any){
        return requestJson({
            url: this.url + '/edit',
            method: 'post',
            data: args
        });
    }

    public delete(args: any){
        return request({
            url: this.url + '/delete',
            method: 'post',
            data: args
        });
    }

    public passOrNot(args: any){
        return request({
            url: this.url + '/pass-or-not',
            method: 'post',
            data: args
        });
    }

    public batchSubmit(args: any){
        return request({
            url: this.url + '/batch-submit',
            method: 'post',
            data: args
        });
    }

    public batchReturn(args: any){
        return request({
            url: this.url + '/batch-return',
            method: 'post',
            data: args
        });
    }

    public batchRescind(args: any){
        return request({
            url: this.url + '/batch-rescind',
            method: 'post',
            data: args
        });
    }


    public batchRevoke(args: any){
        return request({
            url: this.url + '/batch-revoke',
            method: 'post',
            data: args
        });
    }

    public batchReleaseOrRecall(args: any){
        return request({
            url: this.url + '/batch-release-or-recall',
            method: 'post',
            data: args
        });
    }

    public batchEditUseStatus(args: any){
        return request({
            url: this.url + '/batch-edit-use-status',
            method: 'post',
            data: args
        });
    }

    public autoMaterialNoRepeat(materialNo: string, materialId: number){
        return request({
            url: this.url + '/auto-material-no-repeat',
            method: 'get',
            params: {
                materialNo: materialNo,
                materialId: materialId
            }
        })
    }
}
const materialApi = new MaterialApi();
export {materialApi}
